import { Component, OnInit, HostListener } from '@angular/core';
import { TtScreenBlockService } from './tt-screen-block.service';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'tt-screen-block',
    templateUrl: './tt-screen-block.component.html',
    styleUrls: ['./tt-screen-block.component.css']
})
export class TtScreenBlockComponent implements OnInit {
    isBlocked$ = this.screenBlockService.isBlocked$;
    templateId = '';
    message = '';
    progress = 0;

    // Dynamically calculated width for the spinner box
    widthPx = '600px';
    marginLeftPx = '-300px';

    constructor(private screenBlockService: TtScreenBlockService) { }

    ngOnInit(): void {
        // Subscribe to changes in templateId, message, progress
        combineLatest([
            this.screenBlockService.templateId$,
            this.screenBlockService.message$,
            this.screenBlockService.progress$
        ]).subscribe(([tid, msg, prog]) => {
            this.templateId = tid;
            this.message = msg;
            this.progress = prog;
        });

        // Initialize container width based on current window size
        this.updateWidth();
    }

    // Recalculate widths if the window is resized
    @HostListener('window:resize')
    onResize() {
        this.updateWidth();
    }

    private updateWidth(): void {
        const w = window.innerWidth;
        let width = 600;
        if (w <= 420) {
            width = 300;
        } else if (w <= 520) {
            width = 400;
        } else if (w <= 620) {
            width = 500;
        }
        this.widthPx = width + 'px';
        this.marginLeftPx = '-' + width / 2 + 'px';
    }
}
